export default mobileNavigation => {
    $('.mobile-nav-icon').on('click', function (event) {
        event.preventDefault();

        if ($(event.currentTarget).find('.menu-burger').hasClass('is-active')) {
            $('.open-submenu.is-active')
                .removeClass('is-active')
                .parent().parent()
                .find('ul').slideUp();
        }

        $(event.currentTarget).find('.menu-burger').toggleClass('is-active');

        return $('.mobile-nav').toggleClass('is-active');
    });

    let $submenu = $('.open-submenu');

    $submenu.on('click', event => {
        event.stopPropagation();

        let $menu = $(event.currentTarget);

        if ($menu.hasClass('is-active')) {
            $menu.removeClass('is-active');
            $menu.parent().parent().find('ul').slideUp();

            return false;
        }

        $('.open-submenu.is-active')
            .removeClass('is-active')
            .parent().parent()
            .find('ul').slideUp();

        $menu.addClass('is-active');
        $menu.parent().parent().find('ul').slideDown();

        return false;
    });
};